import { render } from "./term_form.vue?vue&type=template&id=e6b7bd46"
import script from "./term_form.vue?vue&type=script&lang=js"
export * from "./term_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__